module.exports = __webpack_public_path__ + "img/img_9.8bf99a4a.jpg";